import { Button } from 'antd';
import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';

const ButtonStyled = styled(Button)`
	&:disabled {
		background: #9d9d9d !important;
		color: #ffffff !important;
	}
	&::active,
	&::focus {
		span {
			color: #ffffff !important;
		}
	}
`;

export default function ButtonGradient(props) {
	return (
		<ButtonStyled
			{...props}
			className={classNames({
				'btn-gradient uppercase': true,
				[`${props.className}`]: props.className,
			})}
			type='text'
		>
			{props.children}
		</ButtonStyled>
	);
}
